<nav mat-tab-nav-bar>
  <a
    mat-tab-link
    [routerLink]="['./info']"
    routerLinkActive
    #rla0="routerLinkActive"
    [active]="rla0.isActive"
  >
    <mat-icon matListIcon>info</mat-icon>&nbsp;&nbsp;&nbsp;Info Generali
  </a>
  <a
    mat-tab-link
    [routerLink]="['./typeform', '1']"
    routerLinkActive
    #rla1="routerLinkActive"
    [active]="rla1.isActive"
  >
    <mat-icon matListIcon>list_alt</mat-icon>&nbsp;&nbsp;&nbsp;Form 1
  </a>
  <a
    mat-tab-link
    [routerLink]="['./typeform', '2']"
    routerLinkActive
    #rla2="routerLinkActive"
    [active]="rla2.isActive"
  >
    <mat-icon matListIcon>list_alt</mat-icon>&nbsp;&nbsp;&nbsp;Form 2
  </a>
  <a
    *ngIf="(user$ | async)?.hasRole('ADMIN')"
    mat-tab-link
    [routerLink]="['./cart']"
    routerLinkActive
    #rla3="routerLinkActive"
    [active]="rla3.isActive"
  >
    <mat-icon matListIcon>shopping_cart</mat-icon>&nbsp;&nbsp;&nbsp;Carrello
  </a>
</nav>

<router-outlet></router-outlet>
